import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
} from "@angular/core";
import { KreFormAntService } from "../../tools/service";
import { KreFormCommonService, KreFormFieldConfig } from "@kre-form/core";

import { KreDialogService } from "../../service/dialog.service";
import * as _ from "lodash";
import { NzMessageService } from "ng-zorro-antd/message";

import { IFormJSON } from "../detail2/index.component";
import { EventComponent } from "../event/event.component";
import { ConfigCodemirrorComponent } from "../config-codemirror/config-codemirror.component";

export interface FormulaParamsOption {
  modalTitle: string;
  title: string;
  fieldVariable?: any;
}

@Component({
  selector: "demo-trigger",
  templateUrl: "./trigger.component.html",
  styleUrls: ["./trigger.component.scss"],
  providers: [KreDialogService, KreFormAntService],
})
export class TriggerComponent implements OnInit, OnChanges {
  // @Input() listData: any[] = [];
  @Input() business_form!: IFormJSON;
  @Input() business_tables: any = {};
  @Input() options: any[] = [];

  @Input() triggerJson: any = {};
  @Input() calculateRuleJson: any = {};

  @Input() random: number = 0;
  @Output() actionEvent: EventEmitter<any> = new EventEmitter<string>();
  @Output() checkFormulaEvent: EventEmitter<any> = new EventEmitter<string>();
  @Output() configFormulaEvent: EventEmitter<any> = new EventEmitter<string>();

  showData: KreFormFieldConfig[] = [];
  list: any[] = [
    { value: "edit", label: "编辑" },
    { value: "trigger", label: "触发事件" },
  ];
  tableScroll = {
    y: "calc( 100vh - 260px)",
    x: "calc( 100vw - 260px)",
  };

  fields: KreFormFieldConfig[] = [];
  keyword: string = "";
  nzTotal: number = 0;
  nzPageSizeOptions: number[] = [10, 20, 40, 80, 100, 200, 400];
  nzPageIndex: number = 1;
  nzPageSize: number = 20;
  getIsChangePageSize: boolean = false;

  time: any = null;

  EditType: any = {
    false: "不可编辑",
    true: "可编辑",
  };
  HideType: any = {
    false: "隐藏",
    true: "显示",
  };
  RequireType: any = {
    false: "不必填",
    true: "必填",
  };

  TableType: any = {
    single: "单记录",
    multiple: "多记录",
  };
  FieldBasicType: any = {
    anchor: "字符型",
    button: "字符型",
    checkbox: "字符型",
    text: "字符型",
    texti18n: "字符型",
    textarea: "字符型（多行文本）",
    numbers: "数字型",
    password: "字符型",
    radio: "字符型",
    radiogroup: "字符型",
    checkboxgroup: "字符型",
    select: "字符型",
    datetime: "时间型",
    "datetime-year": "日期型（年）",
    "datetime-month": "日期型（年月）",
    "datetime-date": "日期型",
    "datetime-time": "时间型",
    "datetime-datetime": "日期时间型",

    image: "图片",
    upload: "附件型",
    htmlcontent: "字符型",
    line: "分割线",
    "drag-drop": "拖拽",
    group: "组",
    repeat: "多记录",
    panel: "组",
    employee: "字符型",
    candidate: "字符型",
    sponsor: "字符型",
    position: "字符型",
    tree: "字符型",
    organizational: "字符型",
    area: "字符型",
    job: "字符型",
    table: "表格",
    lookup: "字符型",
    textBtn: "字符型",
    adjustReportTo: "字符型",
    refer: "字符型",
    avatar: "头像",
    salary: "字符型",
    editor: "富文本",
    dimissContract: "字符型",
    tabular: "字符型",
    tabularItem: "字符型",
  };
  currentShowExpand: number = -1;
  params: FormulaParamsOption = {
    modalTitle: "设置规则", // app.Attendance.Absenteeism rule
    title: "规则",
    fieldVariable: {
      formFields: [],
      tableList: [],
    },
  };
  formFields: any[] = [];
  tableList: any[] = [];
  // tableList = {
  //   fields: [
  //     {
  //       key: "LeaveItem_s1",
  //       label: "事假",
  //       type: "text",
  //       unit: "小时",
  //     },
  //   ],
  //   key: "",
  //   label: "",
  //   unit: "",
  // };
  ruleObj: any = null;
  codeMirrorOptions = {
    autoCloseBrackets: true,
    keywords: [],
    textWrapping: true,
    lineWrapping: true,
    lineNumbers: false,
    matchBrackets: true,
    specialChars: /[\u0000-\u001f\u007f\u00ad\u200c-\u200f\u2028\u2029\ufeff]/,
    mode: "formula",
    labelMap: null,
    autofocus: false,
  };
  constructor(
    private dyService: KreFormAntService,
    private kreDialogService: KreDialogService,
    private message: NzMessageService,
    public kreFormCommonService: KreFormCommonService
  ) {}

  ngOnInit() {}
  ngOnChanges() {
    this.fields = [];
    const fields: KreFormFieldConfig[] = this.business_form.fields;
    fields!.forEach((field: any) => {
      if (
        (
          ["select", "text", "numbers", "textarea", "upload", "datetime"] as any
        ).includes(field.type) ||
        (field.type === "position" &&
          field!.templateOptions!.selectType === "single")
      ) {
        this.fields.push(field);
      }

      if (field.type === "repeat") {
        (field!.fieldArray!.fieldGroup as any[])!.forEach((repeatItem: any) => {
          if (
            (
              [
                "select",
                "text",
                "numbers",
                "textarea",
                "upload",
                "datetime",
              ] as any
            ).includes(repeatItem.type)
          ) {
            this.fields.push(repeatItem);
          }
        });
      }
    });
    let list: any[] = [];
    let tableList = [];
    if (!!this.business_tables && this.business_tables!.primary) {
      tableList = [
        this.business_tables!.primary,
        ...this.business_tables!.child.single,
      ];
      list = [...tableList, ...this.business_tables!.child.multiple];

      this.business_tables!.primary["tableType"] = "single";
      if (!_.isEmpty(this.business_tables!.child.single)) {
        (this.business_tables!.child.single as any[]).forEach((table: any) => {
          table["tableType"] = "single";
        });
      }
      if (!_.isEmpty(this.business_tables!.child.multiple)) {
        (this.business_tables!.child.multiple as any[]).forEach(
          (table: any) => {
            table["tableType"] = "multiple";
          }
        );
      }
      if (!!this.business_tables) {
        this.fields.forEach((field: any) => {
          list!.forEach((table) => {
            (table.tableFields as any[]).forEach((elem) => {
              if (field.key === elem.fieldCode) {
                field["tableType"] = table["tableType"];
                field["tableName"] = table["tableName"];
                field["fieldDataType"] = elem["fieldDataType"];
              }
            });
          });
          if (
            (["text", "numbers", "textarea", "datetime"] as any).includes(
              field.type
            ) ||
            (field.type === "position" &&
              field!.templateOptions!.selectType === "single")
          ) {
            let key = (field.key as any).replaceAll(/\$/g, ".");
            this.formFields.push({
              key,
              label: field!.templateOptions!.label,
              type: field.type,
              unit: "",
            });
          }
        });
      }
      // this.params.fieldVariable.formFields = this.formFields;

      let tableCodeList: any = [];
      this.fields.forEach((field) => {
        if (!field["tableType"]) {
          if (!tableCodeList!.includes(field.tableCode)) {
            tableCodeList.push(field.tableCode);
          }
          field["tableType"] = "multiple";
          field["tableName"] = `业务子表${tableCodeList.length}`;
        }
        if (!field["fieldDataType"]) {
          field["fieldDataType"] = this.transLate(
            field.type,
            "type",
            field!.templateOptions!.selectType
          );
        }
      });

      this.nzTotal = this.fields.length;

      this.getShowDate();
      // 自定义时间收集可处理字段
      this.params.fieldVariable.tableList = [];
      this.tableList = [];
      let fields = _.cloneDeep(this.fields);
      // console.log(fields);

      fields.forEach((field: any) => {
        if (
          (
            [
              "text",
              "numbers",
              // "textarea",
              "datetime",
            ] as any
          ).includes(field.type) ||
          (field.type === "position" &&
            field!.templateOptions!.selectType === "single")
        ) {
          if (
            this.tableList.findIndex((table) => table.key === field.tableCode) >
            -1
          ) {
            let index = this.tableList.findIndex(
              (table) => table.key === field.tableCode
            );
            // console.log(field.templateOptions.label);
            (this.tableList[index].fields as any[]).push({
              key: (field.key as any).replace(/\$/g, "."),
              label: `${field.templateOptions.label}--${field.fieldDataType}`,
              type: field.type,
              unit: "",
              tableType: field.tableType,
            });
          } else {
            let fields: any = [];
            fields.push({
              key: (field.key as any).replace(/\$/g, "."),
              label: `${field.templateOptions.label}--${field.fieldDataType}`,
              type: field.type,
              unit: "",
              tableType: field.tableType,
            });

            this.tableList.push({
              fields,
              key: field.tableCode,
              label: field.tableName,
              tableType: field.tableType,
            });
          }
        }
      });
      this.params.fieldVariable.tableList = this.tableList;
    }
    // console.log(this.tableList);
  }

  getShowDate() {
    this.showData = [];

    for (
      let i = (this.nzPageIndex - 1) * this.nzPageSize;
      i < this.nzPageIndex * this.nzPageSize;
      i++
    ) {
      if (!!this.fields[i]) {
        this.showData.push(this.fields[i]);
      }
    }
  }

  nzPageIndexChange(e: number) {
    if (this.getIsChangePageSize) {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.nzPageIndex = 1;
        this.getIsChangePageSize = false;
      }, 0);
      return;
    }
    this.getShowDate();
  }

  search() {
    const fields: any[] = JSON.parse(JSON.stringify(this.fields));
    this.keyword = this.keyword.trim();
    let list: any[] = fields.filter((field) =>
      (field!.templateOptions!.label as string).includes(this.keyword)
    );
    this.nzPageIndex = 1;

    this.showData = [];

    for (
      let i = (this.nzPageIndex - 1) * this.nzPageSize;
      i < this.nzPageIndex * this.nzPageSize;
      i++
    ) {
      if (!!list[i]) {
        this.showData.push(list[i]);
      }
    }

    // this.getShowDate();
  }

  nzPageSizeChange(e: number) {
    this.nzPageIndex = 1;
    this.getIsChangePageSize = true;
    this.getShowDate();
  }

  transLate(
    value: any,
    type: "hide" | "required" | "edit" | "type" | "tableType",
    selectType?: string
  ) {
    let str: any;
    switch (type) {
      case "hide":
        str = this.HideType[value] || "显示";
        break;
      case "required":
        str = this.RequireType[value] || "不必填";
        break;
      case "edit":
        str = this.EditType[value] || "可编辑";
        break;
      case "type":
        if (!!selectType && selectType === "multiple") {
          str = this.FieldBasicType["select-multiple"];
        } else {
          str = this.FieldBasicType[value];
        }
        break;

      case "tableType":
        str = this.TableType[value];
        break;

      default:
        break;
    }

    return str;
  }
  clickAction(value: string, data: KreFormFieldConfig) {
    // if (!this.canAddEvent(data)) {
    //   return;
    // }
    switch (value) {
      case "edit":
        this.dyService.fieldOperational("edit", data);

        break;
      case "trigger":
        this.trigger(data);
        break;
      // case "Codemirror":
      // this.Codemirror(data);
      // break;
      default:
        break;
    }
  }

  // this.Codemirror(data);

  codemirror(data: any) {
    // if (!this.canSetRule(data)) {
    //   return;
    // }

    // this.calculateRuleJson =;
    console.log("dddd", data);
    let nzTitle = `${data!.tableName ? data!.tableName + "-" : ""}${
      data!.templateOptions!.label
    }（${this.transLate(data!.type, "type")}）-规则`;

    // console.log(data);
    // this.fields.forEach((el: any) => {
    //   if (this.field.tableType === "single") {
    //     if (
    //       (this.typeList as any)!.includes(el.type) &&
    //       el.key !== this.field.key
    //     ) {
    //       this.changeItem!.push(el);
    //     }
    //   } else {
    //     if (
    //       (this.typeList as any)!.includes(el.type) &&
    //       el.key !== this.field.key &&
    //       (el.tableCode === this.field.tableCode || el.tableType === "single")
    //     ) {
    //       this.changeItem!.push(el);
    //     }
    //   }

    //   if (el.key === this.field.key) {
    //     this.selectItemType =
    //       el.templateOptions!.selectType === "multiple"
    //         ? "multiple"
    //         : "default";
    //   }
    // });
    let fieldData = _.cloneDeep(this.params.fieldVariable);
    if (data.tableType === "multiple") {
      let tableList = _.cloneDeep(fieldData.tableList);
      let newTableList: any[] = [];
      (tableList as any[]).forEach((table) => {
        if (table.tableType === "single") {
          newTableList.push(table);
        }
        if (table.tableType === "multiple" && table.key === data.tableCode) {
          newTableList.push(table);
        }
      });
      fieldData.tableList = newTableList;
    }

    // console.log(fieldData);
    this.configFormulaEvent.emit({
      data,
      nzTitle,
      fieldData,
    });

    // let ruleObj = "";
    // if ((this.calculateRuleJson as Object).hasOwnProperty(data.key)) {
    //   ruleObj = this.calculateRuleJson[data.key]["calculateValue"];
    //   if (!!ruleObj && (ruleObj as string).includes("&&_widget_")) {
    //     ruleObj = (ruleObj as any).replaceAll("$", ".");
    //     ruleObj = (ruleObj as string).replace(/&&_widget_/g, "$_widget_");
    //   }
    // } else {
    //   this.calculateRuleJson[data.key] = {
    //     calculateValue: null,
    //     calculateText: null,
    //   };
    // }
    // this.kreDialogService.CreateModelDialogField(
    //   {
    //     nzTitle,
    //     size: "large",
    //     nzContent: ConfigCodemirrorComponent,
    //   },
    //   {
    //     type: "Daycalculation",
    //     title: nzTitle,
    //     fieldData: this.params.fieldVariable,
    //     options: this.codeMirrorOptions,
    //     ruleObj,
    //   },
    //   (actType: any, instance: any, modal: any) => {
    //     let ruleValue = _.cloneDeep(instance.ruleObj);
    //     if (!!ruleValue) {
    //       ruleValue = (ruleValue as string).replace(/$_widget_/g, "&&_widget_");
    //       ruleValue = (ruleValue as any).replaceAll(".", "$");
    //     }

    //     this.calculateRuleJson[data.key] = {
    //       calculateValue: ruleValue,
    //       calculateText: instance.showText,
    //     };
    //     console.log(this.calculateRuleJson);

    //     modal.destroy();
    //     let newFormInfo: any = _.cloneDeep(this.business_form);
    //     this.actionEvent.emit({
    //       newFormInfo,
    //       triggerJson: this.triggerJson,
    //       calculateRuleJson: this.calculateRuleJson,
    //     });
    //     // }
    //   }
    // );
  }
  showText(data: any) {
    let calculateText = "";
    if ((this.calculateRuleJson as Object).hasOwnProperty(data.key)) {
      calculateText = this.calculateRuleJson[data.key]["calculateText"];
    }
    return calculateText;
  }

  getTriggerJson(data: any) {
    let triggerJson: any;
    // if (!!triggerJson) {
    if (data["table"] === "multiple") {
      if (
        !!this.triggerJson[data!.Pkey] &&
        !!this.triggerJson[data!.Pkey][data!.key]
      ) {
        triggerJson = this.triggerJson[data!.Pkey][data!.key];
      } else {
        triggerJson = null;
      }
    } else {
      triggerJson = this.triggerJson[data!.key] || null;
    }
    // }

    return !_.isEmpty(triggerJson);
  }

  isSetRule(data: any) {
    // console.log(this.calculateRuleJson);

    return (
      !_.isEmpty(this.calculateRuleJson) &&
      !_.isEmpty(this.calculateRuleJson[data!.key]) &&
      !!this.calculateRuleJson[data!.key]["calculateText"]
    );
  }

  trigger(data: any) {
    // console.log(data , this.triggerJson);
    let triggerJson: any;
    if (data["table"] === "multiple") {
      if (
        !!this.triggerJson[data!.Pkey] &&
        !!this.triggerJson[data!.Pkey][data!.key]
      ) {
        triggerJson = this.triggerJson[data!.Pkey][data!.key];
      } else {
        triggerJson = null;
      }
    } else {
      triggerJson = this.triggerJson[data!.key] || null;
    }
    this.kreDialogService.CreateModelDialogField(
      {
        nzTitle: `${data!.tableName ? data!.tableName + "-" : ""}${
          data!.templateOptions!.label
        }（${this.transLate(data!.type, "type")}）-触发事件`,
        size: "large",
        nzContent: EventComponent,
      },
      {
        data,
        fields: this.fields,
        options: this.options,
        triggerJson,
      },
      (type: any, instance: any, modal: any) => {
        instance.save();
        if (!instance.validateForm.valid) {
          return;
        }
        let eventList = _.cloneDeep(instance!.validateForm!.value!.eventList);
        let newEventList = this.getUnique3(eventList);

        // console.log(instance.validateForm);
        if (newEventList!.length < eventList!.length) {
          this.message.warning("当前触发事件存在多条完全相同的配置，请检查！");
          return;
        }

        if (data["table"] === "multiple") {
          if (!this.triggerJson[data!.Pkey]) {
            this.triggerJson[data!.Pkey] = {};
          }

          this.triggerJson[data!.Pkey][data!.key] =
            instance!.validateForm!.value!.eventList;
        } else {
          this.triggerJson[data!.key] =
            instance!.validateForm!.value!.eventList;
        }
        let newFormInfo: any = _.cloneDeep(this.business_form);
        this.kreFormCommonService.initFormFieldProperty(newFormInfo.fields);
        this.actionEvent.emit({
          newFormInfo,
          triggerJson: this.triggerJson,
          calculateRuleJson: this.calculateRuleJson,
        });

        modal.destroy();
        // }
      }
    );
  }

  getUnique3(arr: any[]) {
    const map: any = {};

    arr.forEach((item: any) => {
      const obj: any = {};
      // 1、把数组中的元素（对象）的键名抽成一个数组然后排序
      // 2、生成一个按照键名排序好的对象
      Object.keys(item)
        .sort()
        .map((key) => (obj[key] = item[key]));

      // 3、把新生成的对象作为对象的键存起来
      map[JSON.stringify(obj)] = item;
    });

    // 4、再把新对象的键名抽成一个数组返回即为不重复的集合
    return Object.keys(map).map((key) => JSON.parse(key));
  }
  setRule(data: any, j: number) {
    if (this.currentShowExpand === j) {
      this.currentShowExpand = -1;
    } else {
      this.params.title = "data.value.itemName" + "规则";
      this.params = { ...this.params };
      this.currentShowExpand = j;
    }
  }

  canAddEvent(data: any) {
    return (
      ["select", "text", "numbers", "textarea", "upload"] as any
    ).includes(data.type);
  }
  canSetRule(data: any) {
    return (["text", "numbers", "datetime"] as any).includes(data.type);
    // && data.tableType === "single"
    // || data.type === "position" && data!.templateOptions!.selectType === "single";
  }

  // checkFormula(data: any): void {
  //   let ruleObj = "";

  //   if ((this.calculateRuleJson as Object).hasOwnProperty(data.key)) {
  //     ruleObj = this.calculateRuleJson[data.key]["calculateValue"];
  //   }
  //   this.checkFormulaEvent.emit({ ruleObj });
  // }
}
